import { buildUrl, replaceParameters } from '@/common-utils/functions/restUtils';
import merchantUserFields from '../../fields/merchantUserFields';

const { client } = require('@/common-utils/libraries/axios/axios');
const { default: MERCHANT_USER } = require('../apiUrls');

/**
 * @param root0
 * @param root0.items
 * @param root0.totalResults
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    const data = {};

    const mappedItems = items.map(item => ({
        [merchantUserFields.UUID.key]: item[merchantUserFields.UUID.key],
        [merchantUserFields.EMAIL.key]: item[merchantUserFields.EMAIL.key],
        [merchantUserFields.IS_ADMIN.key]: item[merchantUserFields.IS_ADMIN.key],
        [merchantUserFields.STATUS.key]: item[merchantUserFields.STATUS.key],
        [merchantUserFields.CREATED_AT.key]: item[merchantUserFields.CREATED_AT.key],
        [merchantUserFields.UPDATED_AT.key]: item[merchantUserFields.UPDATED_AT.key],
        [merchantUserFields.LAST_LOGIN_AT.key]: item[merchantUserFields.LAST_LOGIN_AT.key],
        [merchantUserFields.MERCHANT_PROFILE.key]: item[merchantUserFields.MERCHANT_PROFILE.key]
    }));

    data.items = mappedItems;
    data.totalResults = totalResults;
    return data;
}

const queryGetMerchantUsers = ({ query, merchantAccountId }, enabled) => {
    return {
        queryKey: [MERCHANT_USER.DETAILS.queryKey, query, merchantAccountId],
        queryFn: async () => {
            const response = await client.get(buildUrl(replaceParameters(MERCHANT_USER.DETAILS.url, { contractAccessId: merchantAccountId }), query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetMerchantUsers;